import { useEffect, useState } from "react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const dismissed = typeof window !== "undefined" && window.localStorage.getItem("pwa_dismissed");
    if (dismissed === "1") setHidden(true);
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!deferred || hidden) return null;

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };
  const dismiss = () => {
    window.localStorage.setItem("pwa_dismissed", "1");
    setHidden(true);
  };

  return (
    <div data-testid="install-prompt"
         className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm z-40 bg-white border shadow-lg p-4"
         style={{ borderColor: "var(--border)" }}>
      <div className="flex items-start gap-3">
        <div className="font-display text-2xl shrink-0" style={{ color: "var(--cinnabar)" }}>✝</div>
        <div className="flex-1 min-w-0">
          <div className="font-display text-base leading-tight">Installer l'application</div>
          <p className="font-body text-xs mt-1" style={{ color: "var(--ink-2)" }}>
            Accès rapide depuis l'écran d'accueil, scan QR le jour J, fiche d'émargement hors-ligne.
          </p>
          <div className="mt-3 flex gap-2">
            <button data-testid="install-btn" onClick={install} className="btn btn-primary"
                    style={{ padding: "0.5rem 1rem", fontSize: "0.7rem" }}>
              Installer
            </button>
            <button data-testid="install-dismiss" onClick={dismiss} className="btn btn-ghost"
                    style={{ padding: "0.5rem 1rem", fontSize: "0.7rem" }}>
              Plus tard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
